import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var LinkedinColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04 10.07a5.039 5.039 0 0 0 5.039-5.035c0-2.78-2.258-5.05-5.04-5.035A5.04 5.04 0 0 0 0 5.035a5.04 5.04 0 0 0 5.04 5.036ZM44 41.288V25.744c0-8.688-4.646-12.733-10.85-12.704-5.011 0-7.24 2.75-8.492 4.671v-3.318a.699.699 0 0 0-.699-.698h-8.01c-.394 0-.714.305-.7.698.08 3.967.015 19.669-.008 25.45l-.006 1.458c0 .393.32.699.699.699h8.025c.393 0 .7-.32.7-.699v-15.12c0-.859.057-1.688.305-2.3.684-1.702 2.228-3.448 4.835-3.448 3.423 0 4.778 2.605 4.778 6.403v14.45c0 .394.32.7.699.7H43.3c.393 0 .699-.32.699-.7ZM24.658 17.71v.088H24.6a.3.3 0 0 1 .029-.044.306.306 0 0 0 .03-.044ZM9.336 41.986H1.311a.69.69 0 0 1-.7-.7V14.365a.7.7 0 0 1 .7-.699h8.025c.393 0 .7.32.7.699v26.923c0 .393-.321.699-.7.699Z",
    svgColor: "#007AB9"
  }));
});
LinkedinColor.displayName = 'LinkedinColor';
LinkedinColor.defaultProps = {
  'aria-label': 'LinkedinColor'
};
export default LinkedinColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/LinkedinColor.js
// module id = 3581
// module chunks = 11